import { useState } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import ProjectCalendarList from '../components/ProjectCalendarList';
import ProjectCalendarTimeline from '../components/ProjectCalendarTimeline';

export default function ProjectCalendar({ projects, hideName, initialView }) {
  const [currentView, updateView] = useState(initialView || 'timeline');

  return (
    <>
      <div className="py-4">
        <Form>
          <FormGroup check inline>
            <Input
              id="view-timeline"
              type="radio"
              name="view"
              value="timeline"
              onChange={() => updateView('timeline')}
              checked={currentView === 'timeline'}
            />
            <Label for="view-timeline" check>
              Show as timeline
            </Label>
          </FormGroup>
          <FormGroup check inline>
            <Input
              id="view-list"
              type="radio"
              name="view"
              value="list"
              onChange={() => updateView('list')}
              checked={currentView === 'list'}
            />
            <Label for="view-list" check>
              Show as list
            </Label>
          </FormGroup>
        </Form>
      </div>

      {currentView === 'list' ? (
        <ProjectCalendarList projects={projects} hideName={hideName} />
      ) : currentView === 'timeline' ? (
        <ProjectCalendarTimeline projects={projects} hideName={hideName} />
      ) : null}
    </>
  );
}
